import Seo from "@/components/Seo";
import { Section, Container, Btn, ArrowLink } from "@/components/kit";
import { Eyebrow } from "@/lib/anim";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" />
      <Section bg="bone" className="min-h-[70vh] flex items-center">
        <Container size="md" className="!px-0">
          <div className="max-w-2xl">
            <Eyebrow>404</Eyebrow>
            <h1 className="t-display2">That page is not here.</h1>
            <p className="t-lead mt-6 text-[var(--muted)]">The link may be old, or the page may have moved. Try the services, the pricing or the free fit call.</p>
            <div className="mt-9 flex flex-wrap gap-4">
              <Btn to="/" variant="clay">Back to home</Btn>
              <Btn to="/services" variant="outline">See services</Btn>
            </div>
            <div className="mt-8"><ArrowLink to="/sitemap">Or view the full sitemap</ArrowLink></div>
          </div>
        </Container>
      </Section>
    </>
  );
}
